import { render, staticRenderFns } from "./ModalSendNotes.vue?vue&type=template&id=6430527d&"
import script from "./ModalSendNotes.vue?vue&type=script&lang=js&"
export * from "./ModalSendNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports